import { writable } from 'svelte/store';

let siteText            = 'Bona Imóveis';
let siteDescription     = 'Imobiliária - Porto Alegre - RS';

export let tagsSEO      = writable('Serviços Especializados<br class="hidden-sm hidden-xs"> para Condomínios, Síndico<br class="hidden-sm hidden-xs"> Profissional, Locação e<br class="hidden-sm hidden-xs"> Venda de Imóveis em<br class="hidden-sm hidden-xs"> Porto Alegre - RS.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('2');
export const ntSeason		= writable('0');
export const ntSell			= writable('1');

// E-mails
export const mailAtendimento	= writable("ana.claudia@bonaimoveis.com.br");
export const mailLocacao		= writable("augusto.garcia@bonaimoveis.com.br");
export const mailVendas			= writable("augusto.garcia@bonaimoveis.com.br");
export const mailCondominios	= writable("ana.claudia@bonaimoveis.com.br");
export const mailProposta		= writable("ana.claudia@bonaimoveis.com.br");
export const mailLista			= writable("augusto.garcia@bonaimoveis.com.br");
export const mailCadastro		= writable("augusto.garcia@bonaimoveis.com.br");
export const mailAtualize		= writable("augusto.garcia@bonaimoveis.com.br");
export const mailDocumentacao	= writable("augusto.garcia@bonaimoveis.com.br");
export const mailOuvidoria		= writable("breno@bonaimoveis.com.br");
export const mailRH				= writable("rh@bonaimoveis.com.br");

export const textTelefoneVendas		= writable("");
export const linkTelefoneVendas		= writable("");

export const textTelefoneLocacao	= writable("");
export const linkTelefoneLocacao	= writable("");

export const textTelefoneCondominio	= writable("");
export const linkTelefoneCondominio	= writable("");

export const linkVideoVimeo			= writable("https://player.vimeo.com/video/");
export const linkVideoYoutube		= writable("https://www.youtube.com/embed/");

export const whatsappGeral			= writable("555133331662");
export const textWhatsappGeral		= writable("(51) 3333-1662");
export const linkWhatsappGeral		= writable("https://wa.me/555133331662");

export const whatsappVendas			= writable("5551995904434");
export const textWhatsappVendas		= writable("(51) 99590-4434");
export const linkWhatsappVendas		= writable("https://wa.me/5551995904434");

export const whatsappLocacao		= writable("5551995904434");
export const textWhatsappLocacao	= writable("(51) 99590-4434");
export const linkWhatsappLocacao	= writable("https://wa.me/5551995904434");

export const whatsappDocumentacao		= writable("5551995904434");
export const textWhatsappDocumentacao	= writable("(51) 99590-4434");
export const linkWhatsappDocumentacao	= writable("https://wa.me/5551995904434");

export const whatsappCondominio		= writable("5551995726944");
export const textWhatsappCondominio	= writable("(51) 99572-6944");
export const linkWhatsappCondominio	= writable("https://wa.me/5551995726944");

export const whatsappProposta		= writable("5551995551974");
export const textWhatsappProposta	= writable("(51) 99555-1974");
export const linkWhatsappProposta	= writable("https://wa.me/5551995551974");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#tipo_negociacao=1");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#tipo_negociacao=2");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/imoveisbona");
export const linkInstagram      = writable("https://www.instagram.com/bona_imoveis/");
export const linkYoutube        = writable("https://www.youtube.com/channel/UC_gRLLfwOcRefAS3X-4Yl6A");
export const linkLinkedin       = writable("https://www.linkedin.com/company/40907977/admin/feed/posts/");
export const linkTwitter        = writable("");
export const linkBlog	        = writable("");

export const linkMapa           = writable("https://g.page/bonaimobiliaria?share");
export const linkWaze           = writable("https://ul.waze.com/ul?preview_venue_id=202376668.2023832214.7046398&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=jpmkyUPUTAew_7fS3nna-Mdxx58NK-w1&pickup=my_location&dropoff[formatted_address]=Bona%20Administradora%20Im%C3%B3veis%20Ltda%20-%20Rua%20Carlos%20Trein%20Filho%20-%20Auxiliadora%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.024441&dropoff[longitude]=-51.187458");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.432907224426!2d-51.18964658429481!3d-30.024435837307962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951979d2ffb16caf%3A0xcf6702f0fbd07c77!2sBona%20Administradora%20Im%C3%B3veis%20Ltda!5e0!3m2!1spt-BR!2sbr!4v1659467312993!5m2!1spt-BR!2sbr");


export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://digital.bonaimoveis.com.br/bonaimoveisdigital/dashboard");
export const linkConheca        = writable("https://digital.bonaimoveis.com.br/conheca/");
export const linkSolicite       = writable("https://digital.bonaimoveis.com.br/bonaimoveisdigital/login?help=1");
export const linkBoletoFacil    = writable("https://digital.bonaimoveis.com.br/bonaimoveisdigital/login?boleto-facil=1");

export const linkManualSindico  		= writable("/assets/files/Guia_de_Orientacao_do_Sindico_JUN18.pdf");

export const textAtendimento            = writable("De Segunda à Sexta-Feira,<br class='hidden-sm hidden-xs'> das 08h30min às 12h e<br class='hidden-sm hidden-xs'> das 13h às 17h.");
export const textEndereco               = writable("Rua Carlos Trein Filho, 257,<br class='hidden-sm hidden-xs'> bairro Mont Serrat,<br class='hidden-sm hidden-xs'> Porto Alegre - RS.");
export const textCNPJ                   = writable("94.350.907/0001-24");
export const textCreci                  = writable("21708");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidade.pdf");
export const linkPoliticaCookies		= writable("/assets/files/PoliticaDePrivacidade.pdf");

export const textPoliticaCheck 			= writable("Aceito compartilhar meus dados de acordo com a <a href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a> da Bona Imóveis. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.");


export const todosContatos = writable([
	{
		title: 'Atendimento geral',
		icon: '<i class="fal fa-phone-alt"></i>',
		href: 'tel://5133331662',
		target: '_blank',
		phone: '(51) 3333-1662'
	},
	{
		title: 'Locação / Anuncie Imóvel',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551995904434',
		target: '_blank',
		phone: '(51) 99590-4434'
	},
	{
		title: 'Condomínios / Manutenção',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551995726944',
		target: '_blank',
		phone: '(51) 99572-6944'
	},
	{
		title: 'Proposta de administração',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551995551974',
		target: '_blank',
		phone: '(51) 99555-1974'
	},
	{
		title: 'Yelum assistência',
		icon: '<i class="fal fa-phone-alt"></i>',
		href: 'tel://08007025100',
		target: '_blank',
		phone: '0800 702 5100'
	}
]);

export const propostaContatos = writable([
	{
		title: 'Proposta de administração',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551995551974',
		target: '_blank',
		phone: '(51) 99555-1974'
	},
	{
		title: 'Atendimento geral',
		icon: '<i class="fal fa-phone-alt"></i>',
		href: 'tel://5133331662',
		target: '_blank',
		phone: '(51) 3333-1662'
	},
]);

export const comoChegar = writable([
	{
		title: 'Mapa',
		icon: '<i class="fas fa-map-marked-alt color-accent"></i>',
		link: 'https://g.page/bonaimobiliaria?share',
	},
	{
		title: 'Waze',
		icon: '<i class="fab fa-waze color-accent"></i>',
		link: 'https://ul.waze.com/ul?preview_venue_id=202376668.2023832214.7046398&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location',
	},
	{
		title: 'Uber',
		icon: '<i class="fab fa-uber color-accent"></i>',
		link: 'https://m.uber.com/ul/?action=setPickup&client_id=jpmkyUPUTAew_7fS3nna-Mdxx58NK-w1&pickup=my_location&dropoff[formatted_address]=Bona%20Administradora%20Im%C3%B3veis%20Ltda%20-%20Rua%20Carlos%20Trein%20Filho%20-%20Auxiliadora%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.024441&dropoff[longitude]=-51.187458',
	}
]);